export const SALES_QUALIFIER_LINE_TELEPHONE = '016 1884 1224';

export const HTB_ADVISOR_PHONE_NUMBER = '020 4579 0876';

export const EMPLOYMENT_STATUS_TEST_CUSTOM_DATA_INDEX = 2;

export const BUILDING_IDENTIFIER_ERROR_MESSAGE =
    'Enter a flat, building name, or building number';

export const BUILDING_IDENTIFIER_FIELDS = [
    'buildingName',
    'buildingNumber',
    'subBuildingName',
];
